import apis from "../../../apis/api.actions";
import { parseQueryParams } from "../../../utils/formValidate";

export const getAttachments = (data) =>
  apis.getDatas(`/attachment${parseQueryParams(data)}`).then((res) => res);

export const createNewAttachments = (data) =>
  apis.createData(`/attachment`, data).then((res) => res);